import styled from 'styled-components';
import { forTablet, forDesktop } from '@westwing/ui-kit/breakPoints';
import Heading from '@ids/components/Typography/Heading';
import { paragraphStyles } from '@ids/components/Typography/Text';
import Center from '@ids/components/Layout/Center';
import { scrollMarginToSection } from '@ids/components/Layout/utils';

export const HowItWorksSection = styled.section`
    ${scrollMarginToSection}
    margin-bottom: 40px;
`;

export const Title = styled(Heading)`
    margin: 0 20px 1rem;
`;

export const Description = styled.h3`
    ${paragraphStyles}
    margin: 0 20px;

    ${forTablet`
        max-width: 700px;
    `}

    ${forDesktop`
        max-width: 975px;  
    `}
`;

export const ButtonWrapper = styled(Center)`
    padding: 0 5vw;
`;
